import {
  Edit,
  Options,
  Close,
  AlertFilled,
  CheckFilled,
  AlertSquare,
  WarningCircle,
  Tick,
  Clock,
  Help,
  Note,
  Email,
  EmailFilled,
  ArrowUp,
  ArrowDown,
  Response,
  PlusCircle,
  Info,
  ChevronLeft,
  ChevronRight,
  Attachment,
  Sorted,
  Unsorted,
  Download,
  External,
  Plus,
  Statement,
  Sync,
  Pound,
  Dollar,
  Euro,
  EyeHidden,
  EyeVisible,
  Cog,
  Phone,
  Check,
  User,
  Lock,
  Calendar,
  Copy,
  Dispute,
  Transfer,
} from './Icons/index';

const IconMap = {
  copy: Copy,
  transfer: Transfer,
  lock: Lock,
  calendar: Calendar,
  user: User,
  'plus-circle': PlusCircle,
  'alert-filled': AlertFilled,
  'alert-square': AlertSquare,
  'arrow-up': ArrowUp,
  'arrow-down': ArrowDown,
  'check-filled': CheckFilled,
  check: Check,
  clock: Clock,
  close: Close,
  email: Email,
  'email-filled': EmailFilled,
  help: Help,
  info: Info,
  note: Note,
  options: Options,
  pencil: Edit,
  response: Response,
  tick: Tick,
  'warning-circle': WarningCircle,
  'chevron-left': ChevronLeft,
  'chevron-right': ChevronRight,
  attachment: Attachment,
  sorted: Sorted,
  unsorted: Unsorted,
  download: Download,
  external: External,
  plus: Plus,
  statement: Statement,
  sync: Sync,
  pound: Pound,
  dollar: Dollar,
  euro: Euro,
  'eye-hidden': EyeHidden,
  'eye-visible': EyeVisible,
  cog: Cog,
  phone: Phone,
  'dispute-bubble': Dispute,
};

const IconNames = Object.keys(IconMap);

export { IconMap, IconNames };
